import React from 'react';
import { Loading, Box, Row, Column } from './core';
interface StatProps {
  label: string;
  loading?: boolean;
  value?: JSX.Element | string | number | false | null;
}

export const Stat = ({
  label,
  loading,
  value,
}: StatProps): JSX.Element | null => (
  <Row as="tr">
    <Box as="td">{label}</Box>
    <Box as="td">
      <Loading loading={loading}>{value ?? 'N/A'}</Loading>
    </Box>
  </Row>
);
